// extracted by mini-css-extract-plugin
export default {"container":"LinkItem-module__container--uZtuw","leadingIcon":"LinkItem-module__leadingIcon--_rwSU","linkIndicator":"LinkItem-module__linkIndicator--5_w0W"};